import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameRulesComponent } from './game-rules.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [GameRulesComponent],
})
export class GameRulesModule {}



// WEBPACK FOOTER //
// ./ts/app/game-rules/game-rules.module.ts